import { useStaffAccess } from '../../../hooks/useStaffAccess';

/**
 * Can this admin SEND anything to a till from the device page?
 *
 * Fleet actions are an EDIT capability — the same rule HealthTab used before
 * the redesign (`fleetAccess.ts`): a till can be reached from either route, so
 * edit on either section counts. A view-only admin still reads every tab; they
 * just never get a button whose only outcome is the server refusing it.
 */
export function useCanManageFleet(): boolean {
  const staffAccess = useStaffAccess();
  return staffAccess.isOwner
    || staffAccess.levelForPath('/fleet-monitoring') === 'edit'
    || staffAccess.levelForPath('/pos-config') === 'edit';
}
